<template>
  <div class="render-edit">
    <v-icon>mdi-circle-edit-outline</v-icon>
  </div>
</template>

<script>
  export default {
    name: 'RenderEdit'
  }
</script>

<style scoped lang="scss">
  .render-edit {
    display: inline-block;
    padding: 0;
    line-height: inherit;
    border: 0;
    background-color: transparent;
  }
</style>